var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitutionsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 20.25V5C20.25 4.27065 19.9603 3.57118 19.4445 3.05546C18.9288 2.53973 18.2293 2.25 17.5 2.25H7.5C6.77065 2.25 6.07118 2.53973 5.55546 3.05546C5.03973 3.57118 4.75 4.27065 4.75 5V20.25H3.5C3.08579 20.25 2.75 20.5858 2.75 21C2.75 21.4142 3.08579 21.75 3.5 21.75H21.5C21.9142 21.75 22.25 21.4142 22.25 21C22.25 20.5858 21.9142 20.25 21.5 20.25H20.25ZM13.25 7C13.25 6.58579 12.9142 6.25 12.5 6.25C12.0858 6.25 11.75 6.58579 11.75 7V8.25H10.5C10.0858 8.25 9.75 8.58579 9.75 9C9.75 9.41421 10.0858 9.75 10.5 9.75H11.75V11C11.75 11.4142 12.0858 11.75 12.5 11.75C12.9142 11.75 13.25 11.4142 13.25 11V9.75H14.5C14.9142 9.75 15.25 9.41421 15.25 9C15.25 8.58579 14.9142 8.25 14.5 8.25H13.25V7ZM10.5 20.2416H14.5V16.7065C14.5 16.4679 14.4025 16.2325 14.2183 16.0539C14.0329 15.8743 13.7751 15.7681 13.5 15.7681H11.5C11.2249 15.7681 10.9671 15.8743 10.7817 16.0539C10.5975 16.2325 10.5 16.4679 10.5 16.7065V20.2416Z",
    fill: "#FD8A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionsActive);
export default __webpack_public_path__ + "static/media/institutions-active.7d4cfcd029326ecf67f4b63987c7a9fe.svg";
export { ForwardRef as ReactComponent };